import { Component } from 'react';
import { Icon } from 'components/common/icons';

class FileUploaderButton extends Component {
  render() {
    const {
      darkStyle,
      disabled,
      file,
      initialFilename,
      onRemove,
      placeholder,
      theme,
      uppyElementRef
    } = this.props;

    return (
      <div className="uppy" ref={uppyElementRef}>
        {initialFilename || file ? (
          <div
            className="content"
            style={
              disabled
                ? {
                    cursor: 'default',
                    opacity: 0.5,
                    pointerEvents: 'none'
                  }
                : {}
            }
          >
            {initialFilename || file.name}

            <button className="remove" onClick={onRemove} type="button">
              <Icon icon="times" style={{ fontSize: '1.4rem' }} />
            </button>
          </div>
        ) : (
          <div className="content">{placeholder}</div>
        )}

        <style jsx>{`
          .uppy {
            display: inline-block;
            position: relative;
          }
          .content {
            background-color: ${darkStyle
              ? theme.lightGreyDark
              : theme.lightGrey};
            border: 0;
            border-radius: ${theme.buttonBorderRadius};
            color: ${theme.textColorLight};
            display: inline-block;
            font-size: 1.4rem;
            font-weight: 700;
            padding: 6px 10px;
            text-align: center;
          }
          .remove {
            background-color: transparent;
            border: 0;
            color: #5f5f5f;
            cursor: pointer;
            display: 'inline-block';
            margin: 0 0 0 10px;
            padding: 2px 7px;
            position: relative;
            right: -5px;
            transition: color 0.3s;
          }
          .remove:hover {
            color: ${theme.textColor};
          }
          .uppy :global(.uppy-FileInput-container) {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100%;
            z-index: ${initialFilename || file ? -1 : 1};
          }
          .uppy :global(.uppy-FileInput-btn) {
            background-color: #fff;
            border: 0;
            border-radius: ${theme.buttonBorderRadius};
            cursor: ${disabled ? 'default' : 'pointer'};
            margin: 0;
            opacity: ${disabled ? 0.5 : 0.07};
            padding: 0;
            pointer-events: ${disabled ? 'none' : 'auto'};
            position: absolute;
            top: 0;
            bottom: 0;
            transition: background-color 0.3s;
            width: 100%;
          }
          .uppy :global(.uppy-FileInput-btn:hover) {
            background-color: #000;
          }
        `}</style>
      </div>
    );
  }
}

export default FileUploaderButton;
